import React, { useContext } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { ThemeContext } from './contexts/ThemeContext';
import './App.css';
import ThemeToggle from './components/ThemeToggle';
import RefreshButton from './components/RefreshButton';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import Toast from './components/Toast';
import NotificationBanner from './components/NotificationBanner';

const App: React.FC = () => {
  const { theme } = useContext(ThemeContext);

  return (
      <div className={`App ${theme}`}>
        <NotificationBanner />
        <Header />
        <MainContent />
        <RefreshButton />
        <ThemeToggle />
        <Footer />
        <Toast />
        <Analytics />
      </div>
  );
}

export default App;